import { useParams, useLocation } from 'react-router-dom';
import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import { useAppNavigate } from '../../hooks/useAppNavigate';
import PrescriptionMobile from './Prescription.mobile';
import { C } from '@parsina/framework/clinical/src/constants/theme';

const PrescriptionScreen = () => {
  const navigate = useAppNavigate();
  const { patientId } = useParams();
  const { state } = useLocation();
  const { isMobile } = useResponsive();
  const patient = state || { id: patientId };
  return (
    <div style={{ display: 'flex', justifyContent: 'center', background: isMobile ? 'none' : C.bg, flex: 1 }}>
      <div style={{ width: isMobile ? '100%' : '500px', height: isMobile ? '100%' : '90vh', marginTop: isMobile ? 0 : '5vh', boxShadow: isMobile ? 'none' : '0 10px 25px rgba(0,0,0,0.1)', borderRadius: isMobile ? 0 : 24, overflow: 'hidden', display: 'flex' }}>
        <PrescriptionMobile navigate={navigate} patient={patient} />
      </div>
    </div>
  );
};

export default PrescriptionScreen;
